import React from 'react';
import { withRouter } from 'next/router';
import throttle from 'lodash/throttle';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import SVG from '@glowforge/gf-styled/src/components/svg';
import TopNav from '@glowforge/gf-styled/src/components/navigation/top-nav';
import Button from '@glowforge/gf-styled/src/components/button';
import { BREAKPOINTS_ALL } from '@glowforge/gf-styled/src/theme/constants/breakpoints';
import { GLOWFORGE_LANDING_PAGE, GLOWFORGE_STORE } from '../../route-constants';
import { withUser, userContextPropType } from '../../context/UserContext';
import { withFeatureFlags } from '../../context/FeatureFlagsContext';
import getNavbarConfig from './config';

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      belowTheFold: false,
      // showMobileNav: false,
    };

    this.classNames = classnames('buyButton', 'hidden')
    this.isMobileOnLoad = true;

    this.throttledScroll = throttle(this.handleScroll, 200);
  }

  componentDidMount() {
    // Only need scroll listener for homepage.
    if (this.isHome()) {
      window.addEventListener('scroll', this.throttledScroll);
    }

    this.isMobileOnLoad = window.innerWidth <= BREAKPOINTS_ALL.navbarBreakpointDown;
  }

  componentWillUnmount() {
    this.removeScrollListener();
  }

  getBuyButton = () => {
    const { includeBuyButton, ctaLocation, ctaText } = this.props;
    if (!includeBuyButton) {
      return null;
    }

    const { belowTheFold } = this.state;
    this.classNames = classnames('buyButton', {
      // Only hide buyButton if on homepage and 
      // not been below the fold and its mobile on load
      hidden: !belowTheFold && this.isHome() && this.isMobileOnLoad,
    });

    return (
      <Button href={ctaLocation} className={this.classNames} type='primary'>
        {ctaText}
        &nbsp;
        <SVG id='long-arrow-right' />
      </Button>
    );
  };

  /**
   * Keep track of whether the user has scrolled below the fold.
   * Will remove the scroll listener once belowTheFold is true.
   */
  handleScroll = () => {
    const { belowTheFold } = this.state;
    const belowTheFoldHeight = window.innerHeight * 0.8;
    // only set state if it will be different
    if (!belowTheFold && window.scrollY > belowTheFoldHeight) {
      this.setState({ belowTheFold: true });
      this.removeScrollListener();
    }
  };

  /**
   * Toggle mobile navigation visibility
   */
  // toggleMobileNav() {
  //   const { showMobileNav } = this.state;
  //   this.setState({
  //     showMobileNav: !showMobileNav,
  //   });
  // }

  /**
   * Helper to remove scrollListener
   */
  removeScrollListener() {
    this.throttledScroll.cancel();
    window.removeEventListener('scroll', this.throttledScroll);
  }

  isHome() {
    const {
      router: { pathname },
    } = this.props;
    return pathname === GLOWFORGE_LANDING_PAGE.BASE_URI;
  }

  render() {
    const { user, userFetchState, featureFlags } = this.props;
    const buyButton = this.getBuyButton();
    const config = getNavbarConfig(featureFlags);

    // userRoutes in the config are coming back as an object
    // and not an array like routes does.
    // But just in case it turns into an array, let's be safe
    const userRoutes = typeof config.userRoutes === 'object' ? 
      Object.values(config.userRoutes) : config.userRoutes;
    const primaryRoutes = config.routes.filter(route => !route.disabled)
    const {
      router: {
        pathname,
      },
    } = this.props;

    // Just while we have the -rebrand at the end of redirect paths
    const removeRebrand = pathname.replace('-rebrand', '');
    return (
      <TopNav
        user={user}
        userFetchState={userFetchState}
        buttonSection={buyButton}
        routes={{
          primaryRoutes,
          userRoutes,
        }}
        activeLink={removeRebrand}
      />
    );
  }
}

Navbar.propTypes = {
  ctaText: PropTypes.string,
  ctaLocation: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  featureFlags: PropTypes.object,
  includeBuyButton: PropTypes.bool,
  router: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  ...userContextPropType,
};

Navbar.defaultProps = {
  ctaText: 'Buy Glowforge',
  ctaLocation: GLOWFORGE_STORE.BASE_URI,
  featureFlags: {},
  includeBuyButton: true,
};

export default withFeatureFlags(withUser(withRouter(Navbar)));
